import { combineReducers } from "redux";

import { userReducer } from "./user/user.reducer";
import { sellersReducer } from "./sellers/sellers.reducer";
import { productsReducer } from "./products/products.reducer";

export const rootReducer = combineReducers({
	user: userReducer,
	sellers: sellersReducer,
	products: productsReducer
});
